import React from "react";
import { cn } from "utils";

export interface ValueLeftContentProps {
  /** 主值 */
  value: string;
  /** 变化金额 */
  changeAmount?: string;
  /** 自定义类名 */
  className?: string;
}

/**
 * Value 统计的左侧内容组件
 * 显示主值和变化金额
 */
export const ValueLeftContent: React.FC<ValueLeftContentProps> = ({
  value,
  changeAmount,
  className,
}) => {
  return (
    <div className={cn("flex gap-2 items-center min-w-0", className)}>
      <p className="headline_regular_m text-content_primary truncate min-w-0">
        {value}
      </p>
      {changeAmount && (
        <p className="body_medium_m text-content_secondary truncate min-w-0">
          {changeAmount}
        </p>
      )}
    </div>
  );
};
